
import $ from 'jquery';

const initFitanalyticsThankYou = function() {
    var fitAnalyticsData = {
        orderid: window.ACL_ORDER_DATA.orderId,
        shopLanguage: 'de',
        shopCountry: v_country.toUpperCase(),
        currency: $("meta[name='_isoCurrency']").attr("content"),
        userId: $.cookie('fitFinderId')?? null,
        shopSessionId: $.cookie('_gid'),
        products: window.fitAnalyticsDataProducts
    };
    window.fitAnalyticsData = fitAnalyticsData;  
    
};

$( document ).ready( function() {
    if(v_cl === "thankyou")
    {
        initFitanalyticsThankYou();
    }
});

export default initFitanalyticsThankYou;